// Schema-Validation für AuthSession. Eigene Datei (kein React-Import) damit
// es testbar bleibt — Vitest+jsdom + tsx-Modul-Init hatte Trouble mit dieser
// Funktion innerhalb von AuthContext.tsx zu importieren.

export interface AuthSessionShape {
  accessToken: string;
  expiresAt: number;
  user: { id: string; email: string; role: string };
}

export function isValidSession(value: unknown): boolean {
  if (typeof value !== "object" || value === null) return false;
  const s = value as Record<string, unknown>;
  if (typeof s.accessToken !== "string" || s.accessToken.length === 0) return false;
  if (typeof s.expiresAt !== "number" || !Number.isFinite(s.expiresAt)) return false;
  if (typeof s.user !== "object" || s.user === null) return false;
  const u = s.user as Record<string, unknown>;
  return (
    typeof u.id === "string" &&
    typeof u.email === "string" &&
    typeof u.role === "string"
  );
}
